import { contentConstants } from '../constants';

export function contents(state = {}, action) {
  switch (action.type) {

    case contentConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case contentConstants.GETALL_SUCCESS:
      return {
        items: action.contents
      };
    case contentConstants.GETALL_FAILURE:
      return {
        error: action.error
      };

    case contentConstants.DELETE_REQUEST:
      // add 'deleting:true' property to content being deleted
      return {
        ...state,
        items: state.items.map(content =>
          content.id === action.id
            ? { ...content, deleting: true }
            : content
        )
      };
    case contentConstants.DELETE_SUCCESS:
      // remove deleted content from state
      return {
        items: state.items.filter(content => content.id !== action.id)
      };
    case contentConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to content
      return {
        ...state,
        items: state.items.map(content => {
          if (content.id === action.id) {
            // make copy of content without 'deleting:true' property
            const { deleting, ...contentCopy } = content;
            // return copy of content with 'deleteError:[error]' property
            return { ...contentCopy, deleteError: action.error };
          }

          return content;
        })
      };

    default:
      return state
  }
}
